<template>
  <v-container>
    <v-progress-circular
        indeterminate
        color="primary"
        v-if="showLoader"
        :size="70"
        :width="7"
    ></v-progress-circular>
    <v-container v-if="!showSuccess && !errorMessage && !temporaryToken">
      <v-container>
        <v-row align="center"
               justify="center">
          <v-col>
            <h2>Purchase Scanner</h2>
          </v-col>
        </v-row>
        <v-row align="center"
               justify="center">
          <v-col cols="12">
            <v-text-field :disable="showLoader" :error-messages="inputErrorMessage" clearable
                          v-model="identifier" autofocus @keyup.enter="reportPurchase()"
                          label="Phone number or Email"></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center" justify="start" class="no-gutters">
        </v-row>
      </v-container>
      <v-container>
        <v-row style="height:80px">
          <v-col>
            <transition name="fade">
              <v-btn @click="()=>reportPurchase()"
                     :disabled="!identifier || identifier.length === 0 || showLoader">
                Lets Go :)
              </v-btn>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: "Web",
  async created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.temporaryToken = urlParams.get('temporaryToken');
    this.transactionId = urlParams.get('transactionId');
    this.businessId = this.$route.params.businessId;
  },
  mounted() {
    if (this.temporaryToken) {
      this.showLoader = true;
      this.reportPurchase();
    } else {
      this.showLoader = false;
    }
  },
  watch: {},
  data: () => ({
    businessId: null,
    transactionId: null,
    identifier: '',
    temporaryToken: null,
    errorMessage: undefined,
    inputErrorMessage: undefined,
    showLoader: false,
    showSuccess: false,
    purchaseTotalSum: null,
    completed: false,
  }),
  methods: {
    reportPurchase: async function () {
      try {
        this.showLoader = true;
        const identifierType = this.temporaryToken ? 'temporaryToken' : this.identifier.includes('@') ? 'email' : 'phoneNumber'
        const response = await axios.post('/Purchase/Report', {
          transactionId: this.transactionId,
          businessId: this.businessId,
          customer: {
            [identifierType]: this.temporaryToken ? this.temporaryToken : this.identifier
          }
        });
        this.showLoader = false;
        this.showSuccess = true;
        this.showLoader = false;
        console.log(response);
        if (response.data) {
            if(response.data.totalSum){
                try{
                    this.purchaseTotalSum = Intl.NumberFormat().format(parseInt(response.data.totalSum) / 100)
                }
                catch(e){
                    console.log(e.response?.data);
                }
            }
        }
        await this.$router.push({
          name: 'Completed',
          query: {
            transactionId: this.transactionId,
            showSuccess: this.showSuccess,
            errorMessage: this.errorMessage,
            purchaseTotalSum: this.purchaseTotalSum
          }
        });
      } catch (e) {
        console.log(e.response?.data);
        this.showSuccess = false;
        this.showLoader = false;
        switch (e.response?.data?.detail) {
          case 'Purchase already reported':
          case 'Purchase related to a member':
            this.errorMessage = "This Purchase was already submitted";
            break;
          case 'Purchase reporting is progress':
            this.inputErrorMessage = "This purchase is being processed now, please wait a few seconds and try again";
            break;
          case 'Purchase not found':
            this.errorMessage = "Scanned purchase not found";
            break;
          case 'Member not found':
            this.inputErrorMessage = "The phone number/ email is not identified";
            //TODO: quick register flow/ link to the app / registration form
            break;
          case 'Purchase total sum is negative or zero':
            this.errorMessage = "This purchase cannot be reported";
            break;
          case 'Purchase cancelled':
            this.errorMessage = "This purchase is cancelled";
            break;
          case 'Member did not give consent':
            this.errorMessage = "Missing Consent. Please download the app or contact the Point of Sale";
            //TODO: quick register flow/ link to the app / registration form
            break;
          case 'Failed to report Purchase':
          case 'Failed to log purchase':
          case 'Identification type not supported':
          default:
            this.inputErrorMessage = "Failed to submit purchase, please try again";
        }
        if (this.temporaryToken && this.inputErrorMessage) {
          this.errorMessage = "Something went wrong. Please close screen and try again";
        }
        if (this.errorMessage) {
          await this.$router.push({
            name: 'Completed',
            query: {
              transactionId: this.transactionId,
              showSuccess: this.showSuccess,
              errorMessage: this.errorMessage,
              purchaseTotalSum: this.purchaseTotalSum
            },
          });
        }
      }
    },
  },
  computed: {},
  components: {}
}
</script>
<style>
.multi-line {
  white-space: pre-line;
}

.loader {
  margin: 100px auto;
  font-size: 25px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load5 1.1s infinite ease;
  animation: load5 1.1s infinite ease;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

@-webkit-keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #924545, 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.5), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.7), 1.8em -1.8em 0 0em #924545, 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.5), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7), 2.5em 0em 0 0em #924545, 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5), 2.5em 0em 0 0em rgba(146, 69, 69, 0.7), 1.75em 1.75em 0 0em #924545, 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.5), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.7), 0em 2.5em 0 0em #924545, -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.5), 0em 2.5em 0 0em rgba(146, 69, 69, 0.7), -1.8em 1.8em 0 0em #924545, -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.5), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.7), -2.6em 0em 0 0em #924545, -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.5), -2.6em 0em 0 0em rgba(146, 69, 69, 0.7), -1.8em -1.8em 0 0em #924545;
  }
}

@keyframes load5 {
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em #924545, 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.5), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.7), 1.8em -1.8em 0 0em #924545, 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.5), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.7), 2.5em 0em 0 0em #924545, 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.5), 2.5em 0em 0 0em rgba(146, 69, 69, 0.7), 1.75em 1.75em 0 0em #924545, 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.5), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.7), 0em 2.5em 0 0em #924545, -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.2), -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.5), 0em 2.5em 0 0em rgba(146, 69, 69, 0.7), -1.8em 1.8em 0 0em #924545, -2.6em 0em 0 0em rgba(146, 69, 69, 0.2), -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.5), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.7), -2.6em 0em 0 0em #924545, -1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(146, 69, 69, 0.2), 1.8em -1.8em 0 0em rgba(146, 69, 69, 0.2), 2.5em 0em 0 0em rgba(146, 69, 69, 0.2), 1.75em 1.75em 0 0em rgba(146, 69, 69, 0.2), 0em 2.5em 0 0em rgba(146, 69, 69, 0.2), -1.8em 1.8em 0 0em rgba(146, 69, 69, 0.5), -2.6em 0em 0 0em rgba(146, 69, 69, 0.7), -1.8em -1.8em 0 0em #924545;
  }
}
</style>
